export default __webpack_public_path__ + "static/media/banner_5.a154adb3.png";